import { ISwapperOptions, ISwapperQueries } from '../../models/kt';

export const defaultSwapperOptions: ISwapperOptions = {
   mode: 'append',
}

export const defaultSwapperQueires: ISwapperQueries = {
   componentName: 'swapper',
   instanseQuery: '[data-kt-swapper="true"]',
   attrQuery: 'data-kt-swapper-',
}
